import { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { NotificationContext } from '../../providers/NotificationProvider';
import { getLeadForms } from '../../features/user/userSlice';
import DataTable from '../shared/DataTable';
import { useTranslation } from 'react-i18next';
import { LeadFormType } from '../../types/types';

const Leads: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { triggerNotification } = useContext(NotificationContext);
  const [forms, setForms] = useState<LeadFormType[]>([]);

  useEffect(() => {
    dispatch(getLeadForms() as any)
      .then((result: any) => {
        if (getLeadForms.fulfilled.match(result)) {
          setForms(result.payload || []);
          return;
        }

        triggerNotification('error', t('Error'), result.payload?.message || t('No se pudieron cargar los leads.'), 'bottomRight');
      })
      .catch((error: any) => {
        triggerNotification('error', t('Error'), error.message || t('No se pudieron cargar los leads.'), 'bottomRight');
      });
  }, [dispatch, t, triggerNotification]);

  const columns = [
    {
      title: t('Formulario'),
      dataIndex: 'name',
      key: 'name',
      searchable: true,
      render: (_: unknown, item: LeadFormType) => (
        <button
          className='naked'
          type='button'
          onClick={() => navigate(`/leads/${item.key}`)}
          style={{ color: '#1677ff' }}
        >
          {item.name}
        </button>
      ),
    },
    {
      title: t('Cantidad'),
      dataIndex: 'count',
      key: 'count',
    },
  ];

  return (
    <Row className='content'>
      <Col style={{ width: '100%' }}>
        <div className='title-full'>
          <h1>{t('Leads')}</h1>
        </div>
        <div className='ant-divider'></div>
        <DataTable dataSource={forms} columns={columns} rowKey='key' />
      </Col>
    </Row>
  );
};

export default Leads;
